import { render, staticRenderFns } from "./404.vue?vue&type=template&id=0c29aeb2&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"
import style0 from "./404.vue?vue&type=style&index=0&id=0c29aeb2&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c29aeb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Workplace\\vueProject\\edu_aim\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c29aeb2')) {
      api.createRecord('0c29aeb2', component.options)
    } else {
      api.reload('0c29aeb2', component.options)
    }
    module.hot.accept("./404.vue?vue&type=template&id=0c29aeb2&scoped=true", function () {
      api.rerender('0c29aeb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/404.vue"
export default component.exports